import { render } from "./InfoSection.vue?vue&type=template&id=ce5a1a74&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=ce5a1a74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5a1a74"]])

export default __exports__